module.exports = {
	"genre": {
		"genre-id-1": "Varios",
		"genre-id-2": "Blues/Country/Folk",
		"genre-id-3": "Blues",
		"genre-id-4": "Country",
		"genre-id-5": "Folk",
		"genre-id-6": "Chanson francesa",
		"genre-id-7": "Intérpretes de chanson francesa",
		"genre-id-8": "Chanson francesa retro",
		"genre-id-9": "Rock francés",
		"genre-id-10": "Clásica",
		"genre-id-11": "Electrónica o concreta",
		"genre-id-12": "Música concreta",
		"genre-id-13": "Música electrónica",
		"genre-id-14": "Música minimalista",
		"genre-id-15": "Mélodies & Lieder",
		"genre-id-16": "Lieder (Alemania)",
		"genre-id-17": "Lieder",
		"genre-id-18": "Mélodies",
		"genre-id-19": "Canciones (Inglaterra)",
		"genre-id-20": "Canciones (Europa del Norte)",
		"genre-id-21": "Mélodies (Francia)",
		"genre-id-22": "Música concertante",
		"genre-id-23": "Otros instrumentos",
		"genre-id-24": "Conciertos para tecla",
		"genre-id-25": "Conciertos para violín",
		"genre-id-26": "Conciertos para violonchelo",
		"genre-id-27": "Música de cámara",
		"genre-id-28": "Otras formaciones",
		"genre-id-29": "Otros instrumentos a solo",
		"genre-id-30": "Piano solo",
		"genre-id-31": "Cuartetos",
		"genre-id-32": "Quintetos",
		"genre-id-33": "Dúos",
		"genre-id-34": "Tríos",
		"genre-id-35": "Violín solo",
		"genre-id-36": "Violonchelo solo",
		"genre-id-37": "Música sinfónica",
		"genre-id-38": "Ballets",
		"genre-id-39": "Música escénica",
		"genre-id-40": "Música de cine",
		"genre-id-41": "Oberturas",
		"genre-id-42": "Poemas sinfónicos",
		"genre-id-43": "Sinfonías",
		"genre-id-44": "Música vocal (profana y sacra)",
		"genre-id-45": "Cantatas (profanas)",
		"genre-id-46": "Música coral",
		"genre-id-47": "Música para conjuntos vocales",
		"genre-id-48": "Oratorios profanos",
		"genre-id-49": "Recitales vocales",
		"genre-id-50": "Música vocal sacra",
		"genre-id-51": "Cantatas sacras",
		"genre-id-52": "Coros sacros",
		"genre-id-53": "Misas, Pasiones, Réquiems",
		"genre-id-54": "Oratorios sacros",
		"genre-id-55": "Ópera",
		"genre-id-56": "Extractos de ópera",
		"genre-id-57": "Integrales de ópera",
		"genre-id-58": "Opereta",
		"genre-id-59": "Audiolibros",
		"genre-id-60": "Pedagogía",
		"genre-id-61": "Documentos históricos",
		"genre-id-62": "Humor",
		"genre-id-63": "Literatura",
		"genre-id-64": "Electrónica",
		"genre-id-65": "Ambient",
		"genre-id-66": "Downtempo",
		"genre-id-67": "Drum & Bass",
		"genre-id-68": "House",
		"genre-id-69": "Lounge",
		"genre-id-70": "Techno",
		"genre-id-71": "Trance",
		"genre-id-72": "Trip Hop",
		"genre-id-73": "Ambientes infantiles",
		"genre-id-74": "Acordeón",
		"genre-id-75": "Cuentos y fábulas",
		"genre-id-76": "Educativo",
		"genre-id-77": "Karaoke",
		"genre-id-78": "Música militar",
		"genre-id-79": "Relax",
		"genre-id-80": "Jazz",
		"genre-id-81": "Be Bop",
		"genre-id-82": "Cool jazz",
		"genre-id-83": "Free jazz & Vanguardia",
		"genre-id-84": "Gospel",
		"genre-id-85": "Jazz contemporáneo",
		"genre-id-86": "Jazz fusion & Jazz rock",
		"genre-id-87": "Jazz manouche",
		"genre-id-88": "Jazz tradicional & Nueva Orleans",
		"genre-id-89": "Jazz vocal",
		"genre-id-90": "Latin jazz",
		"genre-id-91": "Bandas sonoras",
		"genre-id-92": "Bandas sonoras",
		"genre-id-93": "Comedias musicales",
		"genre-id-94": "World music",
		"genre-id-95": "África",
		"genre-id-96": "Afrobeat",
		"genre-id-97": "Asia",
		"genre-id-98": "Brasil",
		"genre-id-99": "Celta",
		"genre-id-100": "Europa del Este",
		"genre-id-101": "Fado",
		"genre-id-102": "Flamenco",
		"genre-id-103": "Música étnica",
		"genre-id-104": "Música india",
		"genre-id-105": "Oriente",
		"genre-id-106": "Raï",
		"genre-id-107": "Salsa",
		"genre-id-108": "Tango",
		"genre-id-109": "World music",
		"genre-id-110": "Yiddish & Klezmer",
		"genre-id-111": "Zouk & Antillas",
		"genre-id-112": "Pop/Rock",
		"genre-id-113": "Alternative e indie",
		"genre-id-114": "Crooners",
		"genre-id-115": "Hard Rock",
		"genre-id-116": "Metal",
		"genre-id-117": "Pop",
		"genre-id-118": "Punk - New Wave",
		"genre-id-119": "Rock",
		"genre-id-120": "Rock progresivo",
		"genre-id-121": "Rockabilly",
		"genre-id-122": "Música popular internacional",
		"genre-id-123": "Reggae",
		"genre-id-124": "Dancehall",
		"genre-id-125": "Dub",
		"genre-id-126": "Ska & Rocksteady",
		"genre-id-127": "Soul/Funk/R&B",
		"genre-id-128": "Acid jazz",
		"genre-id-129": "Dance",
		"genre-id-130": "Disco",
		"genre-id-131": "Funk",
		"genre-id-132": "R&B",
		"genre-id-133": "Hip-Hop/Rap",
		"genre-id-134": "Soul",
		"genre-id-135": "Opereta",
		"genre-id-137": "Conciertos para trompeta",
		"genre-id-138": "Conciertos para instrumentos de viento",
		"genre-id-139": "Crossover",
		"genre-id-140": "Documentos",
		"genre-id-141": "New Age",
		"genre-id-142": "Ambientes",
		"genre-id-144": "Crossover",
		"genre-id-145": "Dixieland",
		"genre-id-146": "Ragtime",
		"genre-id-147": "Series de TV",
		"genre-id-148": "Vídeojuegos",
		"genre-id-149": "América Latina",
		"genre-id-150": "Norteamérica",
		"genre-id-151": "Europa",
		"genre-id-152": "Gipsy",
		"genre-id-153": "Música tradicional",
		"genre-id-154": "Magreb",
		"genre-id-155": "Rusia",
		"genre-id-156": "Turquía",
		"genre-id-157": "Pop indie",
		"genre-id-158": "Canciones gamberras",
		"genre-id-159": "Músicas gamberras",
		"genre-id-160": "Alemania",
		"genre-id-161": "Escocia",
		"genre-id-162": "España",
		"genre-id-163": "Grecia",
		"genre-id-164": "Irlanda",
		"genre-id-165": "Canción italiana",
		"genre-id-166": "Portugal",
		"genre-id-167": "Infantil",
		"genre-id-176": "Música vocal profana",
		"genre-id-173": "Schlager (Alemania)",
		"genre-id-171": "Stimmungsmusik (Alemania)",
		"genre-id-172": "Volksmusik (Alemania)",
		"genre-id-174": "Celta (Irlanda)",
		"genre-id-175": "Pop (Irlanda)",
		"genre-id-168": "Música folclórica (Suiza)",
		"genre-id-178": "Alemán",
		"genre-id-177": "Inglés",
		"genre-id-170": "Francés",
		"genre-id-179": "Neerlandés",
		"genre-id-180": "Bolero",
		"genre-id-181": "Urban latino",
		"genre-id-182": "Reguetón",
		"genre-id-183": "MPB",
		"genre-id-184": "Bossa Nova",
		"genre-id-185": "Samba",
		"genre-id-186": "Forró",
		"genre-id-187": "Pagode",
		"genre-id-188": "Funk brasileño",
		"genre-id-189": "Sertanejo",
		"genre-id-190": "Música japonesa",
		"genre-id-191": "J-Pop",
		"genre-id-192": "Música tradicional japonesa",
		"genre-id-193": "Música coreana",
		"genre-id-194": "K-Pop",
		"genre-id-195": "Música tradicional coreana",
		"genre-id-196": "Anime/Videojuegos",
		"genre-id-197": "Anime"
	},
	"article-cat": {
		"article-cat-2": "– ARCHIVOS GENERALES –",
		"article-cat-4": "Encuentros",
		"article-cat-5": "-- ARCHIVES GER / LIRE / CLASSICA --",
		"article-cat-7": "En escena",
		"article-cat-8": "Nominaciones y premios",
		"article-cat-10": "En la prensa",
		"article-cat-22": "Obituarios",
		"article-cat-51": "Discografía",
		"article-cat-53": "Bibliografía",
		"article-cat-54": "Retratos",
		"article-cat-97": "Actualidad",
		"article-cat-98": "Principales reseñas",
		"article-cat-100": "Industria",
		"article-cat-101": "Novedades",
		"article-cat-117": "JazzNews",
		"article-cat-122": "Actualidad",
		"article-cat-189": "Entrevista",
		"article-cat-197": "Escucha comparada",
		"article-cat-199": "Encuentros",
		"article-cat-209": "J'ai la mémoire qui chante",
		"article-cat-226": "Cave Canem",
		"article-cat-227": "Fortissimo",
		"article-cat-229": "Peux-tu ?",
		"article-cat-238": "Magazine: reseñas",
		"article-cat-252": "Callassotherapy",
		"article-cat-260": "Le symphoman",
		"article-cat-267": "Cruces",
		"article-cat-279": "Conciertos",
		"article-cat-286": "Confidencial",
		"article-cat-287": "Agenda",
		"article-cat-293": "Eventos",
		"article-cat-295": "Conciertos y giras",
		"article-cat-297": "Hi-Fi",
		"article-cat-298": "Bancos de pruebas",
		"article-cat-299": "Práctico",
		"article-cat-301": "Actualidad",
		"article-cat-302": "Tomas de sonido excepcionales",
		"article-cat-303": "Los Magos del Sonido",
		"article-cat-304": "Trax",
		"article-cat-305": "De la vieille cire dans des oreilles propres",
		"article-cat-306": "Voxpop",
		"article-cat-311": "Orquesta Filarmónica de Berlín",
		"article-cat-312": "André Tubeuf: Memoria y paisajes",
		"article-cat-315": "François Hudry : Cum grano salis",
		"article-cat-316": "Qibuz Clásica",
		"article-cat-318": "Los editoriales",
		"article-cat-319": "Qobuz en",
		"article-cat-320": "Marsella",
		"article-cat-321": "Festival Paris Baroque",
		"article-cat-322": "Los locos de la Hi-Fi",
		"article-cat-323": "Rennes",
		"article-cat-324": "Editoriales",
		"article-cat-325": "Qobuz",
		"article-cat-326": "El editorial de Jean-Michel Proust",
		"article-cat-327": "Jean-Michel Proust: la actualidad del mes",
		"article-cat-328": "Qibuz Lunes",
		"article-cat-329": "Lille",
		"article-cat-330": "Yes Masters !",
		"article-cat-331": "El Minuto Qobuz",
		"article-cat-332": "Moderno",
		"article-cat-333": "Newsletters",
		"article-cat-334": "Newsletter Qobuz Semanal",
		"article-cat-335": "Newsletter Promociones",
		"article-cat-336": "Newsletter Qobuz Hi-Fi",
		"article-cat-337": "Newsletter Clásica",
		"article-cat-339": "Newsletter Electrónica",
		"article-cat-340": "Newsletter Infantil",
		"article-cat-341": "Newsletter Audiolibros",
		"article-cat-342": "Smartphones compatibles audio-HD",
		"article-cat-343": "Newsletter Chanson française",
		"article-cat-344": "France Musique",
		"article-cat-345": "Estilo Moderno",
		"article-cat-347": "Newsletter Ambientes",
		"article-cat-350": "En Inglés",
		"article-cat-351": "En Alemán",
		"article-cat-352": "En Neerlandés",
		"article-cat-353": "En Inglés",
		"article-cat-354": "En Alemán",
		"article-cat-355": "En Neerlandés",
		"article-cat-356": "En Neerlandés",
		"article-cat-357": "En Alemán",
		"article-cat-358": "En Inglés",
		"article-cat-359": "Vieux Sequins et Vieilles Cuirasses",
		"article-cat-360": "Hannah Krooz",
		"article-cat-361": "Tutorials",
		"article-cat-362": "Novedades de clásica",
		"article-cat-363": "Studio Qobuz",
		"article-cat-364": "Qobuz Studio",
		"article-cat-365": "Actualidad",
		"article-cat-368": "Archivos",
		"article-cat-369": "Qobuz Chef",
		"article-cat-370": "One Cover One Word"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/apiLocale/apiEs.json
// module id = 559
// module chunks = 0